import { useEffect, useRef, useState } from 'react';
import { getImageThumbnail } from '../Core/FetchData';
import { getImagePreview } from '../Core/ImagePreview';
import './SelectionList.css';

const placeholder = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="300" height="300"/%3E';

export default function SelectionThumbnail({ image, alt }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    const [thumbnail, setThumbnail] = useState(null);
    const [decodedSrc, setDecodedSrc] = useState(null);
    const [failedSrc, setFailedSrc] = useState(null);

    useEffect(() => {
        if (typeof IntersectionObserver === 'undefined') {
            setVisible(true);
            return;
        }
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setVisible(true);
                observer.disconnect();
            }
        }, { rootMargin: '200px' });
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (!visible) return;
        let active = true;
        getImageThumbnail(image).then((src) => {
            if (active) setThumbnail({ image, src });
        }).catch(() => {
            if (active) setThumbnail({ image, src: null });
        });
        return () => { active = false; };
    }, [image, visible]);

    const src = (thumbnail?.image === image && thumbnail.src) || placeholder;
    const state = src !== placeholder && decodedSrc === src ? 'ready'
        : ((thumbnail?.image === image && !thumbnail.src) || failedSrc === src ? 'error' : 'loading');

    const reveal = async (event) => {
        const element = event.currentTarget;
        const loadedSrc = element.getAttribute('src');
        if (loadedSrc === placeholder) return;
        try {
            // Do not expose partially decoded image pixels during loading.
            if (element.decode) await element.decode();
        } catch {
            // A successful load event is sufficient on browsers that reject decode().
        }
        if (ref.current === element && element.getAttribute('src') === loadedSrc) {
            setDecodedSrc(loadedSrc);
        }
    };

    return <>
        <img src={getImagePreview(image)} className="selection-preview" alt="" aria-hidden="true"
            width="300" height="300" />
        <img ref={ref} src={src} className="selection-thumbnail" data-thumbnail-state={state}
        onLoad={reveal} onError={() => setFailedSrc(src)}
        alt={alt} width="300" height="300" decoding="async" />
    </>;
}
